import { useRequest, useUrlParams } from '@byted/hooks';

import cls from 'classnames';
import { Button, Space, Pagination, Spin } from '@douyinfe/semi-ui';
import { IconPlus } from '@douyinfe/semi-icons';
import { useEffect } from 'react';
import { useHistory } from '@jupiter/plugin-runtime/router';
import style from './index.module.scss';
import { forumPostService } from '@/api/forumPost';
import { useUserInfo } from '@/hooks/useUserInfo';
import { useInsertPostGroupModal } from '@/components/NoticeCard/hooks';
import { STD_DATE_FORMAT_RE } from '@/consts';
import { useScope } from '@/hooks/useScope';

function usePosts() {
  return useRequest(
    async ({
      id,
      page,
      limit,
    }: {
      id: string;
      page: number;
      limit: number;
    }) => {
      try {
        const res = await forumPostService.getPostsByGroupId({
          GroupId: id,
          PageNo: page,
          PageSize: limit,
        });
        if (res.error) {
          throw new Error(res.message);
        }
        return res.data;
      } catch (e) {
        // toastError(e);
      }
      return undefined;
    },
    {
      auto: false,
    },
  );
}

export const Billboard = () => {
  const { setValue, value } = useUrlParams<{
    title?: string;
    id?: string;
    page?: number;
    limit?: number;
  }>({
    page: 1,
    limit: 10,
  });

  const { page, limit, id } = value;

  const { ifAdmin } = useUserInfo();
  const { data, run, loading } = usePosts();

  useEffect(() => {
    run({ id, page, limit });
  }, [id, page, limit]);

  const { renderAddPostModal: renderModal } = useInsertPostGroupModal();
  const scope = useScope();
  const history = useHistory();
  return (
    <div className="">
      <Spin spinning={loading}>
        <div className={cls(style.container, 'mx-auto')}>
          <div className="flex justify-between items-center">
            <div className="my-8 font-medium text-2xl">
              {data?.GroupInfo.Name}
            </div>
            <div>
              {ifAdmin && (
                <Button
                  type="primary"
                  theme="solid"
                  onClick={() => {
                    renderModal(id, async () => {
                      await run({ id, page, limit });
                    });
                  }}>
                  <Space align="center">
                    <IconPlus />
                    添加帖子
                  </Space>
                </Button>
              )}
            </div>
          </div>
          <div className="bg-white rounded-xl px-8">
            {data?.GroupInfo.PostList.map(item => (
              <div
                key={item.Id}
                onClick={() => {
                  history.push(`/${scope}/post/${item.Id}`);
                }}
                className="cursor-pointer hover:text-semi-color-link py-6 border-b border-semi-color-border flex justify-between items-center">
                <div className="text-lg font-medium break-all">
                  {item.Title}
                </div>
                <div className="text-semi-color-text-2">
                  {item.CreatedAt.replace(STD_DATE_FORMAT_RE, '$1/$2/$3')}
                </div>
              </div>
            ))}
            <div className="flex">
              <Pagination
                className="ml-auto py-6"
                total={data?.TotalNum}
                currentPage={page}
                pageSize={limit}
                onChange={(current, size) => {
                  setValue(prev => ({
                    ...prev,
                    page: current,
                    limit: size,
                  }));
                }}
              />
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default Billboard;
